<template>
  <b-navbar-nav class="flex-row justify-content-between">
    <b-button
      v-for="(item, idx) in list"
      :key="idx"
      :href="item.link"
      target="_blank"
      variant="outline-secondary"
    >
      <icon :name="item.icon" />
    </b-button>
  </b-navbar-nav>
</template>

<script>
  /* eslint-disable import/no-extraneous-dependencies */
  import 'vue-awesome/icons/brands/facebook-f';
  import 'vue-awesome/icons/brands/twitter';
  import 'vue-awesome/icons/brands/viadeo';
  /* eslint-enable import/no-extraneous-dependencies */

  export default {
    name: 'SocialNetworksComponent',
    props: {
      list: {
        type: Array,
        default: () => [{
          icon: 'brands/facebook-f',
          link: 'https://www.facebook.com/pages/PCIE-ECDL-France-Passeport-de-Comp%C3%A9tences-Informatique-Europ%C3%A9en/180254541984667',
        }, {
          icon: 'brands/twitter',
          link: 'https://twitter.com/PCIE_ECDL',
        }, {
          icon: 'brands/viadeo',
          link: 'http://fr.viadeo.com/fr/groups/?containerId=002112bibxumjgdl',
        }],
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
  ul {
    max-width: 150px;
    margin-right: auto;

    .btn {
      width: 40px;
      line-height: 0;
      padding: 1rem .75rem;

      &:not(:last-child) {
        margin-right: 1rem;
      }
    }
  }
</style>
